import React from "react";
import getId from "utils/getId";

const useId = (arg?: string) => {
  const id = React.useRef(getId(arg));
  return id.current;
};

export default useId;
